<template>
    <v-app>
        <v-navigation-drawer
            width="300"
            v-model="drawer"
            app
        >
            <v-list dense>
                <template v-for="item in items">
                    <v-list-group
                        v-if="item.children"
                        :key="item.text"
                        v-model="item.model"
                        :prepend-icon="item.model ? item.icon : item['icon-alt']"
                        append-icon=""
                    >
                        <template v-slot:activator>
                            <v-list-item-content>
                                <v-list-item-title>
                                {{ item.text }}
                                </v-list-item-title>
                            </v-list-item-content>
                        </template>
                        <v-list-item
                            link
                            v-for="(child, i) in item.children"
                            :key="i"
                            :to="child.link"
                        >
                            <div class="d-flex pl-8">
                                <v-list-item-action v-if="child.icon">
                                    <v-icon>{{ child.icon }}</v-icon>
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title>
                                    {{ child.text }}
                                    </v-list-item-title>
                                </v-list-item-content>
                            </div>
                        </v-list-item>
                    </v-list-group>
                </template>
            </v-list>
        </v-navigation-drawer>

        <v-app-bar
            app
            color="primary"
            dark
        >
            <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
            <v-toolbar-title>Class dashboard</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text @click="logout">
                <v-icon>mdi-logout</v-icon> Log out
            </v-btn>
        </v-app-bar>

        <v-content>
            <v-layout color="grey lighten-5">
                <router-view/>
            </v-layout>
        </v-content>
    </v-app>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'dashboardLayout',
        data: () => ({            
            drawer: null,
        }),
        computed: {
            items() {
                return [
                    {
                        icon: 'mdi-chevron-up',
                        'icon-alt': 'mdi-chevron-down',
                        text: 'Configuration/Administration',
                        model: false,
                        children: [
                            { icon: 'mdi-earth', text: 'Countries' , link: `/${this.$i18n.locale}/administrator/countries`},
                            { icon: 'mdi-cog', text: 'Config Parameters', link: `/${this.$i18n.locale}/administrator/configparameters`},
                            { icon: 'mdi-school-outline', text: 'Education Levels', link: `/${this.$i18n.locale}/administrator/levels`},
                            { icon: 'mdi-chat', text: 'Feedback', link: `/${this.$i18n.locale}/administrator/feedback`},
                            { icon: 'mdi-google-translate', text: 'Languages' , link: `/${this.$i18n.locale}/administrator/languages`},
                            { icon: 'mdi-card-text', text: 'Labels', link: `/${this.$i18n.locale}/administrator/labels` },
                            { icon: 'mdi-email', text: 'Mail Templates', link: `/${this.$i18n.locale}/administrator/mailtemplates`},
                            { icon: 'mdi-account-question', text: 'Leave reasons', link: `/${this.$i18n.locale}/administrator/reasons`},
                            { icon: 'mdi-school', text: 'Student Academic Levels', link: `/${this.$i18n.locale}/administrator/studentacademiclevels`},
                            { icon: 'mdi-cash-usd', text: 'Subscription packages', link: `/${this.$i18n.locale}/administrator/subscriptions` },
                            { icon: 'mdi-earth', text: 'States', link: `/${this.$i18n.locale}/administrator/states` },
                            { icon: 'mdi-book-open-variant', text: 'Teaching subjects' , link: `/${this.$i18n.locale}/administrator/subjects`},
                            { icon: 'mdi-google-translate', text: 'Translations', link: `/${this.$i18n.locale}/administrator/translations` },
                            { icon: 'mdi-file-check-outline', text: 'Terms and Conditions', link: `/${this.$i18n.locale}/administrator/terms` }
                        ]
                    },
                    {
                        icon: 'mdi-chevron-up',
                        'icon-alt': 'mdi-chevron-down',
                        text: 'Statistics and Business Intelligence',
                        model: false,
                        children: [
                            { icon: 'mdi-account', text: 'Students' , link: `/${this.$i18n.locale}/administrator/students` },
                            { icon: 'mdi-account-tie', text: 'Mentors' , link: `/${this.$i18n.locale}/administrator/tutors`},
                            { icon: 'mdi-account-supervisor', text: 'Parents' , link: `/${this.$i18n.locale.iso}/administrator/parents`},
                            { icon: 'mdi-calendar', text: 'Sessions' , link: `/${this.$i18n.locale}/administrator/sessions` },
                            { icon: 'mdi-book-clock', text: 'Session Requests' , link: `/${this.$i18n.locale}/administrator/sessionsrequired` },
                            { icon: 'mdi-account-voice', text: 'Mentor Requests' , link: `/${this.$i18n.locale}/administrator/tutorrequired` },
                            { icon: 'mdi-star', text: 'Reviews' , link: `/${this.$i18n.locale}/administrator/reviews` },
                            { icon: 'mdi-account-box', text: 'Bids', link: `/${this.$i18n.locale}/administrator/creative/bids` },
                            { icon: 'mdi-view-dashboard', text: 'Statistics', link: `/${this.$i18n.locale}/administrator/statistics` }
                        ]
                    },
                    {
                        icon: 'mdi-chevron-up',
                        'icon-alt': 'mdi-chevron-down',
                        text: 'E-Creative',
                        model: false,
                        children: [
                            { icon: 'mdi-message', text: 'Topics' , link: `/${this.$i18n.locale}/administrator/creative/topics` },
                            { icon: 'mdi-lightbulb-on', text: 'Projects' , link: `/${this.$i18n.locale}/administrator/creative/projects` }
                        ]
                    }
                ]
            }
        },
        methods: {
            logout() {
                this.$store.dispatch('logout')
                this.$router.push('/login')
            }
        }
    }
</script>

<style lang="scss">
.v-list-item{
    padding: 0 10px;
}
.v-application--is-ltr .v-list-item__action:first-child, .v-application--is-ltr .v-list-item__icon:first-child{
    margin-right: 10px !important;
}
</style>